// list-groups.component.ts
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { TableAction } from 'src/app/shared/components/table-paginator/table-paginator.component';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import { GruposService } from 'src/app/core/services/grupos.service'; // 👈 usa el servicio
import { CertificadoService } from 'src/app/core/services/certificado.service';
import { SearchFunction } from 'src/app/shared/components/search-autocomplete/search-autocomplete.component';
import Swal, { SweetAlertIcon } from 'sweetalert2';

// Lo que espera el componente internamente
interface Grupo {
    id: number;
    nombre: string;
    padre_id: number | null;
    orden: number;
}

interface Item {
    id_user?: string;
    usuario: string;
    correo: string;
    estado: string;
}

interface Item2 {
    id?: string;
    nombre: string;
    scratchcard: string;
}

@Component({
    selector: 'app-list-groups',
    templateUrl: './group-users.component.html',
    styleUrls: ['./group-users.component.css']
})
export class GroupUserComponent implements OnInit {

    formGrupo: FormGroup;
    searchForm: FormGroup;
    searchFormScracth: FormGroup;
    private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente

    fullData: Item[] = []; // Tu conjunto completo de datos
    currentItems: Item[] = []; // Los datos para la página actual

    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;
    spinnerSearch: boolean;
    spinnerSelect = false;
    showSelect = false;
    idGroup: string;
    showDropdown: boolean = false

    tableHeaders = [
        { key: 'usuario', label: 'Usuario' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'correo', label: 'Correo' },
        { key: 'estado', label: 'Estado' }
    ];

    // Definición de las acciones personalizadas
    customActions: TableAction[] = [];


    //ADD CERTIFICADOOOO
    data: Item[] = []; // Los datos para la página actual
    currentItemsScratch: Item2[] = []; // Los datos para la página actual
    selectedScratchcard = null;
    userSelected = null;

    // Toast
    toast = Swal;
    search: SearchFunction;


    constructor(private gruposService: GruposService,
        private modalService: NgbModal, // ¡Inyecta el servicio NgbModal!
        private route: ActivatedRoute,
        private router: Router,
        private usuarioService: UsuariosService,
        private certificadoService: CertificadoService,
        private fb: FormBuilder
    ) {
        this.search = this.getUser2.bind(this);

        this.formGrupo = this.fb.group({
            nombre: new FormControl('', [Validators.required]),
            padreId: new FormControl(null, [])
        });

    }

    ngOnInit(): void {
        this.route.paramMap
            .pipe(takeUntil(this.destroy$))
            .subscribe(async params => {
                
                const id = params.get('id');

                this.idGroup = id;
            });
        this.spinnerSelect = false;

        this.customActions = [
            {
                label: 'Editar',
                handler: (item: Item) => this.removeAsignacionGrupo(item),
                icon: 'fa-solid fa-trash',
                colorClass: 'bg-red'
            },
        ];

        this.toastAlert();
        this.initSearchForm();
        this.getUserGroup();
    }

    initSearchForm(): void {
        this.searchForm = this.fb.group({
            search: ['', [Validators.required]]
        })

        this.searchFormScracth = this.fb.group({
            search: ['', [Validators.required]]
        })
    }

    async getUserGroup() {
        this.spinner = true;
        const search = this.searchForm.value.search;
        let params = new HttpParams();
        params = params.set('page', this.currentPage).set('limit', this.pageSize).set('pagination', true).set('id_grupo', String(this.idGroup)).set('email', String(search));
        const result = await lastValueFrom(this.usuarioService.getGrupoUsuarios(params));

        const headers: HttpHeaders = result.headers;
        this.spinner = false;
        this.currentItems = result.body.map((x: any, index: number) => {

            return {
                id_user: x.id,
                nombre: (x.usuario.firstName + ' ' + x.usuario.lastName),
                usuario: (x.usuario.username), correo: x.usuario.email, estado: (x.usuario.isActive === true ? 'Activo' : 'Inactivo'),
            }
        });

        this.totalItems = Number(headers.get('X-Total-Count'));
    }

    redericGrupoUser() {
        this.router.navigate(['groups/list-group']);
    }

    onPageChange(newPage: number): void {
        this.currentPage = newPage;
        this.getUserGroup();
    }

    onPageSizeChange(newSize: number): void {
        this.pageSize = newSize;
        this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
        this.getUserGroup();
    }

    async getUser2(search: string = '' ) {
        this.spinnerSearch = true;
       
        const result = await lastValueFrom(this.usuarioService.getUsuarios(1, 1, search, 'false'));

        this.spinnerSearch = false;
       return this.data = result.body.map((x: any, index: number) => {

            return {
                id_user: x.id,
                nombre: (x.firstName + ' ' + x.lastName),
                usuario: (x.username), correo: x.email, estado: (x.isActive == true ? 'Activo' : 'Inactivo')
            }
        });
    }

    async getCertifacodoUser(idUsuario: string) {
        this.spinnerSelect = true;
        this.showSelect = false;
        const result = await lastValueFrom(this.certificadoService.getCertificados(idUsuario));
        this.currentItemsScratch = result.body.map((x: any, index: number) => {

            return {
                id: x.id,
                nombre: x.nombre,
                scratchcard: x.scratchcard,
                estado: (x.estado == true ? 'Activo' : 'Inactivo')
            }
        });
        this.spinnerSelect = false;
        this.showSelect = true;
    }

    async asignarUsuarioGrupo() {

        if (!this.selectedScratchcard) {
            this.alert('warning', 'Debe seleccionar un scratchcard para agregar el usuario al grupo');
            return;
        }
        Swal.fire({
            title: "Asignar Usuario a Grupo!",
            text: "Desea asignar este usuario",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Agregar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {

                await lastValueFrom(this.usuarioService.asignUserGroup(
                    {
                        id_usuario: this.userSelected.id_user,
                        id_grupo: this.idGroup,
                        id_certificado: this.selectedScratchcard.id
                    }));
                this.getUserGroup();
                this.alert('success', 'Usuario asignado correctamente');
                await this.getUserGroup();


            }
        });
    }

    selectItem(item: any): void {
        this.searchFormScracth.get('search')?.setValue(item.correo, { emitEvent: false });

        this.getCertifacodoUser(item.id_user);
        this.userSelected = item;
        this.showDropdown = false;
    }


    async removeAsignacionGrupo(item: any) {

        Swal.fire({
            title: "Eliminar asignación!",
            text: "Desea eliminar el usuario de este grupo",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await lastValueFrom(this.usuarioService.deleteGrupo(item.id_user));
                this.getUserGroup();
                this.alert('success', 'Asignación eliminada correctamente');
                await this.getUserGroup();
            }
        });

    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string) {
        this.toast.fire({
            icon: icontext,
            title: title
        });
    }
}
